import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from "../../assets/images/adm_logo.png";

// Public layout for the legal pages. Sits outside ProtectedRoutes and
// PublicRoutes so it opens with or without a login and never redirects —
// carriers and Brevo check these URLs as anonymous visitors.
const Legal = ({ title, lastUpdated, children }) => {
  useEffect(() => {
    document.title = `${title} | ADM Client Portal`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link to="/login"><img src={logo} width="200px" alt="ADM One" /></Link>
        <div className="legal-byline">by ADM CPA P.C.</div>
      </header>
      <main className="legal-content">
        <h1>{title}</h1>
        <p className="legal-updated">Last Updated: {lastUpdated}</p>
        {children}
      </main>
      <footer className="legal-footer">
        <span>&copy; {new Date().getFullYear()} ADM CPA P.C.</span>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms">Terms &amp; Conditions</Link>
      </footer>
    </div>
  );
};

export default Legal;
